import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ProfileDisplayPage } from '../pages/profile-display/profile-display.page';
import { LoginSharedPage } from '../pages/login-shared/login-shared.page';
import { LoginPage } from '../pages/login/login.page';

@Injectable({
  providedIn: 'root'
})
export class OpenProfileService {

  public souls: any[] = [];

  constructor(public modalCtrl: ModalController) { }

  public setSouls(souls: any[]): void {
    this.souls = souls;
  }

  async openProfile(soul: any): Promise<any[]> {
    try {
      console.log('OpenProfileFromLikes, soul:', soul);
  
      // Abre o modal com o perfil
      const modal = await this.createProfileModal(soul);
  
      // Processa a resposta do modal
      await this.handleModalResponse(modal, soul);
  
    } catch (error) {
      console.error('Erro ao abrir o perfil:', error);
    }
    return this.souls;
  }

  private async createProfileModal(soul: any) {
    return this.modalCtrl.create({
      component: ProfileDisplayPage,
      componentProps: { theSoul: soul },
    });
  }
  
  private async handleModalResponse(modal: HTMLIonModalElement, soul: any): Promise<void> {
    // Primeiro, apresenta o modal
    await modal.present();
  
    // Depois, espera o fechamento do modal
    const { data } = await modal.onDidDismiss();
  
    if (data === 'logout') {
      this.goToLoginPage();
    }
    // Remove a alma da lista se for "removed"
    else if (data === 'removed') {
      this.removeSoul(soul);
    } 
    // Desenvolva outras ações, como "liked", se necessário
    // else if (data === 'liked') {
    //   this.triggerLikeAndRemoveSoulAnimation(soulIndex);
    // }
  }
  
  private removeSoul(soul: any): void {
    const index = this.souls.findIndex(item => item === soul);
    if (index !== -1) {
      this.souls.splice(index, 1);
      console.log('Objeto removido com sucesso:', soul);
    } else {
      console.warn('Objeto não encontrado para remoção:', soul);
    }
  }

  async goToLoginPage() {
    if (window.location.href.indexOf(`https://web.flamr.app/?referralUserId=`) === 0) {
      let currentUrl = window.location.href;
      let referralUserId = currentUrl.substring(`https://web.flamr.app/?referralUserId=`.length);

      referralUserId = referralUserId.substring(0, referralUserId.length);

      this.modalCtrl.create({ component: LoginSharedPage, componentProps: { referralUserId: referralUserId } }).then((modal) => {
        modal.present();
      });

    } else {
      this.modalCtrl.create({ component: LoginPage }).then((modal) => {
        modal.present();
      });
    }
  }

  handleAnimation(animation: string, targetId: string, delay: number, duration: number) {
    setTimeout(() => document.getElementById(targetId)?.classList.add(animation), delay);
    setTimeout(() => document.getElementById(targetId)?.classList.remove(animation), duration + delay);
  }

}
